import moment from 'moment';
import momentTz from 'moment-timezone';
import parse from 'html-react-parser';
import { notification } from 'antd';
import settings from './config/settings';

export const resHandle = res => {
    let status = res.data.statusCode;
    let data;
    if (status) {
        data = res.data.responseData
    } else {
        data = res.data.error.responseMessage
    }
    return { status, data }
}

//const emailPattern = /(([a-zA-Z0-9\-?\.?]+)@(([a-zA-Z0-9\-_]+\.)+)([a-z]{2,3}))+$/;
const emailPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$";

const passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
var formatSpecialCharactersCheck = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
export const isValidEmail = e => new RegExp(emailPattern).test(e);
export const isValidPassword = e => new RegExp(passwordPattern).test(e);
export const specialCharactersCheck = e => new RegExp(formatSpecialCharactersCheck).test(e);


export const removeTime = t => {
    let time = new Date(t);
    time.setUTCHours(0);
    time.setUTCMinutes(0);
    time.setUTCSeconds(0);
    time.setUTCMilliseconds(0);  
    return time.getTime();
}


export const lineChartOptions = {
    maintainAspectRatio: true,
    responsive: true,
    scales: {
        xAxes: [{ display: false, }], yAxes: [{ display: false, }],
    }, legend: {
        display: false,
    },
}


export const checkStringContainsNumbers = str => /\d/.test(str);



export const titleCase = str => {
    let splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
}


export const programDates = (startdate, enddate) => {
    let sDate = new Date(parseInt(startdate))
    let eDate = new Date(parseInt(enddate))
    let startmonthname =   moment.utc(sDate).format('MMM')
    let endmonthname =  moment.utc(eDate).format('MMM')
    let startmonthdate = sDate.getDate();
    let endmonthdate = eDate.getDate();
    if (sDate.getTime() === eDate.getTime()) {
        return `${startmonthname} ${startmonthdate}`;
    }
    else {
        return `${startmonthname} ${startmonthdate} - ${endmonthname} ${endmonthdate}`;
    }


}

export const dateFormatfordays = (startdate, endDate) => {
  let sDate = new Date(isNaN(startdate) ? startdate : parseInt(startdate))
  let eDate = new Date(isNaN(endDate) ? endDate : parseInt(endDate))
  let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
 return days[sDate.getUTCDay()]+'-' + days[eDate.getUTCDay()];
}



export const campDates = (startdate, endDate) => {
    let sDate = new Date(parseInt(startdate))
    let eDate = new Date(parseInt(endDate))
    let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let monthnamstart =  moment.utc(sDate).format('MMM');
    let monthnamend = moment.utc(eDate).format('MMM');
    let startmonthdate = sDate.getUTCDate();
    let endmonthdate = eDate.getUTCDate();

    if (sDate.getTime() === eDate.getTime()) {
        return monthnamstart + ' ' + startmonthdate + ', ' + sDate.getFullYear() + ' - ' + monthnamend + ' ' + endmonthdate + ', ' + eDate.getFullYear() + ' (' + days[eDate.getUTCDay()] + ')';
    }


    return monthnamstart + ' ' + startmonthdate + ', ' + sDate.getFullYear() + ' - ' + monthnamend + ' ' + endmonthdate + ', ' + eDate.getFullYear() + ' ( ' + days[sDate.getUTCDay()] + '-' + days[eDate.getUTCDay()] + ')';
}


export const campDates2 = (startdate, endDate) => {
    let sDate = new Date(parseInt(startdate))
    let eDate = new Date(parseInt(endDate))
    let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    let monthnamstart =  moment.utc(sDate).format('MMM');
    let monthnamend = moment.utc(eDate).format('MMM');
    let startmonthdate = sDate.getUTCDate();
    let endmonthdate = eDate.getUTCDate();

    if (sDate.getTime() === eDate.getTime()) {
        return monthnamstart + ' ' + startmonthdate + ', ' + sDate.getFullYear() + ' - ' + monthnamend + ' ' + endmonthdate + ', ' + eDate.getFullYear() + ' (' + days[eDate.getUTCDay()] + ')';
    }


    return monthnamstart + ' ' + startmonthdate + ', ' + sDate.getFullYear() + ' - ' + monthnamend + ' ' + endmonthdate + ', ' + eDate.getFullYear() + ' ( ' + days[sDate.getUTCDay()] + '-' + days[eDate.getUTCDay()] + ')';
}


export const dateFormat = date => moment.utc(date).format('MM/DD/YYYY');

export const dateFormat2 = val => {
    let d = new Date(val)
    return (d.getUTCMonth()+1) + '/' + d.getUTCDate() + '/' + d.getUTCFullYear()
}

export const formatDate = date => {
    return (date.startDate.getMonth()+1 + '/' + date.startDate.getDate() + '/' + date.startDate.getFullYear()) + ' - ' + (date.endDate.getMonth()+1 + '/' + date.endDate.getDate() + '/' + date.endDate.getFullYear())
}

export const timeFormat = date => moment(date).format('h:mm a');


export const mealsArr = ['breakfast', 'lunch', 'dinner']


export const programTypes = [
    { value: 0, label: 'All' },
    { value: 1, label: 'Morning Half Day' },
    { value: 2, label: 'Afternoon Half Day' },
    { value: 3, label: 'Full Day' },
    { value: 4, label: 'Full Day Extended' },
    { value: 5, label: 'Overnight' }
]

// `?.label ?? ''` for the same reason as `getFacility` below: this is reachable from the
// audit trail (`formatAuditValue`), where a legacy or out-of-range code must not be able
// to throw. An unrecognized type renders as nothing rather than crashing the page.
export const getProgramType = (val=0) => {
    if(val === null || val === 'undefined' || val === ''){
        return 'All'
    }else {
        return programTypes.find(item => item.value === Number(val))?.label ?? ''
    }

};


export const genders2 = [
    { value: 1, label: 'Male' },
    { value: 2, label: 'Female' },
    { value: 3, label: 'Non-Binary' }
]

export const genders3 = [
    { value: 1, label: 'Male' },
    { value: 2, label: 'Female' },
    { value: 3, label: 'Co-Ed' }
]

export const genders = [
    { value: 1, label: 'Male' },
    { value: 2, label: 'Female' },
    { value: 3, label: 'Non-Binary' }
]

export const gendersTwo = [
    { value: 1, label: 'Male' },
    { value: 2, label: 'Female' },
]



export const gendersdisplay = [
    { value: 1, label: 'Male' },
    { value: 2, label: 'Female' },
    { value: 3, label: 'Co-Ed' }
]

export const removeHtmlTags = e => {
    if(e){
        return e.replace(/(<([^>]+)>)/gi, " ");
    }
    
}


export const getGender = val => {
    if(val){
        return genders.find(item => item.value === Number(val))?.label ?? '';
    }
};


export const getgendersdisplay = val => {
    if(val){
        return gendersdisplay.find(item => item.value === Number(val))?.label ?? ''
    }
};

export const trueFalse = [
    { value: 2, label: 'No' },
    { value: 1, label: 'Yes' },
]

// 0/1 rather than trueFalse's 2/1 — this is the shape `isprivate` is stored in.
// Numbers, like every other option list here: the API returns these coded fields as
// Numbers and the forms compare with ===, so string values matched nothing and the
// dropdown sat on its placeholder no matter what was stored.
export const trueFalse2 = [
    { value: 0, label: 'No' },
    { value: 1, label: 'Yes' },
]
/**
 * Amenity option lists — the single source of truth for these four coded fields.
 *
 * Labels are the API Excel importer's canonical strings
 * (`campsez_api/lib/module/v1/program/programFacade.js:989-1052`), so a Download Excel →
 * edit → Upload Excel round-trip maps back to the same codes. Keep them in step: the
 * importer matches on the exact string.
 *
 * These lived in `ProgramForm/sections/Amenities.js` when the form was redesigned, which
 * left every display path in the app resolving through the legacy `facilies` list below
 * and crashing on the new codes. They belong here, where both the form and the display
 * code can reach them.
 */

// Legacy facility codes. Deliberately NOT extended with 4-9: the legacy AddProgramModal
// renders this list as its own dropdown, and `Amenities.js` diffs against it to detect a
// program still holding an old value. Use `ALL_FACILITIES` for lookups instead.
//
// `exportLabel` because the importer matches value 3 on the short "Both" while the UI
// shows the descriptive form.
export const facilies = [
    { value: 1, label: 'Outdoor' },
    { value: 2, label: 'Indoor' },
    { value: 3, label: 'Both indoor and outdoor facilities', exportLabel: 'Both' },
]

// The six options the redesigned form offers. No new value means "both indoor and
// outdoor", so legacy value 3 is kept selectable rather than remapped onto one of these.
export const facilitiesNew = [
    { value: 4, label: 'Indoor gymnasium' },
    { value: 5, label: 'Outdoor fields' },
    { value: 6, label: 'Aquatic center' },
    { value: 7, label: 'Equestrian center' },
    { value: 8, label: 'Cabins & lodge' },
    { value: 9, label: 'Classroom building' },
]

// New first so the current options lead the dropdown, legacy after.
export const ALL_FACILITIES = [...facilitiesNew, ...facilies];

// Code 1 was "Yes" for all three of these, and stays the offering-something answer.
export const tshirtOpt = [
    { value: 1, label: 'Included' },
    { value: 2, label: 'Not provided' },
    { value: 3, label: 'Available for purchase' },
]

export const scholarshipOpt = [
    { value: 1, label: 'Available' },
    { value: 2, label: 'Not available' },
    { value: 3, label: 'Limited availability' },
]

export const travelOpt = [
    { value: 1, label: 'Bus transportation' },
    { value: 2, label: 'Not included' },
    { value: 3, label: 'Shuttle service' },
    { value: 4, label: 'Family drop-off' },
]

/**
 * Travel codes that make Travel Info a required field: bus (1) and shuttle (3), the two
 * where the camp is moving campers itself. Not included (2) and family drop-off (4) have
 * nothing to describe. Display code gates the Travel Info block on the same rule, so it
 * lives here rather than in the director form — otherwise a shuttle program's required
 * text is collected and never shown.
 */
export const TRAVEL_NEEDS_INFO = [1, 3];

// Scholarships codes that have a URL to link to: available (1) and limited (3).
export const SCHOLARSHIP_HAS_URL = [1, 3];

/**
 * Total label lookup: an unmapped code yields '' rather than throwing.
 *
 * The previous `getFacility` assumed `.find()` always matched and read `.label` straight
 * off it. When the form started writing facility codes 4-9 that assumption broke, and
 * because this app has no error boundary anywhere, the TypeError unmounted the whole
 * React tree — five pages, four of them camper-facing, went blank on a single bad integer.
 * Returning '' keeps a stale or future code to a missing label instead of a dead page.
 */
const labelFor = (list, val) =>
    (val === '' || val === null || val === undefined)
        ? ''
        : (list.find(item => Number(item.value) === Number(val))?.label ?? '');

export const getFacility = val => labelFor(ALL_FACILITIES, val);
export const getTshirt = val => labelFor(tshirtOpt, val);
export const getTravel = val => labelFor(travelOpt, val);
export const getScholarship = val => labelFor(scholarshipOpt, val);

// Excel export needs the importer's spelling, which differs from the display label for
// facility 3 alone. Falls back to the display label for every other code.
export const getFacilityExport = val => {
    if (val === '' || val === null || val === undefined) return '';
    const match = ALL_FACILITIES.find(item => Number(item.value) === Number(val));
    return match ? (match.exportLabel || match.label) : '';
};



export const daysArr = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

export const medicalList = ['None', 'ADHD', 'Amputation', 'Anxiety/Depression', 'Asperger', 'Asthma/Respiratory Ailment', 'Autism', 'Behavior/Emotional Problems', 'Blood Disorder', 'Brain Injury', 'Burn', 'Cancer', 'Celliac Disease', 'Cerebral Palsy', 'Craniofacial', 'Crohn’s Disease / Colitis', 'Cystic Fibrosis', 'Diabetes', 'Down Syndrome', 'Epilepsy', 'Hearing Impairment/Deaf', 'Heart Defects', 'Hemophilia', 'HIV/Aids', 'Intellectual Disability', 'Leukemia', 'Mobility Limitation', 'Muscular Dystrophy', 'Obsessive Compulsive Disorder', 'Organ Transplant', 'Post-Traumatic Stress', 'Prader-Will Syndrome', 'Sickle Cell', 'Skin Disorder', 'Speech/Communication Impairment', 'Spina Bifida', 'Substance Abuse', 'Tourette Syndrome', 'Visual Impairment / Blind', 'Weight Loss', 'Other']

export const allergyList = ['None', `Cow's Milk`, 'Eggs', 'Tree Nuts', 'Peanuts', 'Shellfish', 'Wheat', 'Soy', 'Fish', 'Gluten', 'Other'];


export const gradeArr = [
    'Pre-school',
    'Kindergarten',
    '1st',
    '2nd',
    '3rd',
    '4th',
    '5th',
    '6th',
    '7th',
    '8th',
    '9th',
    '10th',
    '11th',
    '12th',
    'Camper is older than 18'
]

// The last gradeArr entry is a sentinel, not a school grade — keep the two apart so a
// derived grade can never land on it by clamping.
export const GRADE_OVER_18 = gradeArr[gradeArr.length - 1];
export const SCHOOL_GRADES = gradeArr.slice(0, -1);

const SCHOOL_YEAR_CUTOFF_MONTH = 8; // September, 0-indexed
const SCHOOL_YEAR_CUTOFF_DAY = 1;
const KINDERGARTEN_START_AGE = 5;
const SCHOOL_YEAR_ROLLOVER_MONTH = 4; // May, 0-indexed


// A school year is named for the September it starts in, but we start naming the next one on
// May 1, while spring registration for it is running: on 1 May 2027 the forms move to 2027-28.
// The label and the grade estimate both read from this, so they can never disagree.
const schoolYearStartYear = now => now.getMonth() >= SCHOOL_YEAR_ROLLOVER_MONTH
    ? now.getFullYear()
    : now.getFullYear() - 1;


// dob reaches us as a timestamp, a numeric string from the API, a Date or a moment.
const toDateOfBirth = value => {
    if (value === null || value === undefined || value === '') return null;
    const ms = typeof value === 'object' ? value.valueOf() : Number(value);
    if (isNaN(ms)) return null;
    const date = new Date(ms);
    return isNaN(date.getTime()) ? null : date;
}


const ageOn = (birthDate, onDate) => {
    let age = onDate.getFullYear() - birthDate.getFullYear();
    const hadBirthday = onDate.getMonth() > birthDate.getMonth() ||
        (onDate.getMonth() === birthDate.getMonth() && onDate.getDate() >= birthDate.getDate());
    if (!hadBirthday) age -= 1;
    return age;
}


// "2026-27" for the school year currently being named — see schoolYearStartYear.
export const getSchoolYearLabel = (now = new Date()) => {
    const startYear = schoolYearStartYear(now);
    return `${startYear}-${`${(startYear + 1) % 100}`.padStart(2, '0')}`;
}


// Estimates the grade for the school year getSchoolYearLabel names, measuring age at that
// year's September 1 cutoff. Returns '' for an unusable dob so callers leave the stored
// grade alone.
export const deriveGradeFromDob = (dob, now = new Date()) => {
    const birthDate = toDateOfBirth(dob);
    if (!birthDate) return '';

    if (ageOn(birthDate, now) > 18) return GRADE_OVER_18;

    const cutoff = new Date(schoolYearStartYear(now), SCHOOL_YEAR_CUTOFF_MONTH, SCHOOL_YEAR_CUTOFF_DAY);
    const index = ageOn(birthDate, cutoff) - KINDERGARTEN_START_AGE + 1;
    return SCHOOL_GRADES[Math.max(0, Math.min(SCHOOL_GRADES.length - 1, index))];
}


export const MAX_INSURANCE_PRODUCTS = 2;

export const gradeArr2 = [
    {count: 1, value: 'Pre-school'},
    {count: 2, value: 'Kindergarten'},
    {count: 3, value: '1st'},
    {count: 4, value: '2nd'},
    {count: 5, value: '3rd'},
    {count: 6, value: '4th'},
    {count: 7, value: '5th'},
    {count: 8, value: '6th'},
    {count: 9, value: '7th'},
    {count: 10, value: '8th'},
    {count: 11, value: '9th'},
    {count: 12, value: '10th'},
    {count: 13, value: '11th'},
    {count: 14, value: '12th'},
    {count: 15, value: 'Participant is older than 18'}
]





export const ageArr = ['0-5', '6-10', '11-15', '16-20', '21-25', '26-30', '31-35', '36-40', '41-45', '46-50', '51-55', '56-60', '61-65', '66-70', '71-75', '76-80', '81-85', '86-90', '91-95', '96-100']

export const PriceArr = ['$25-300', '$300-600', '$600-1,200', '$1,200-2,500', '$2,500-4,000', '$4,000-6,000', '$6,000-8,000', '$8,000+']
export const statusArr = ["Live", "Cancelled"]


export const removeTime003 = t => {
    let time = new Date(t);
    time.setUTCDate(time.getDate());
    time.setUTCHours(0);
    time.setUTCMinutes(0);
    time.setUTCSeconds(0);
    time.setUTCMilliseconds(0);
    return time.getTime();
}

export const removeTime2 = t => {
    let time = new Date(t);
    time.setUTCDate(time.getDate());
    time.setUTCHours(0);
    time.setUTCMinutes(0);
    time.setUTCSeconds(0);
    time.setUTCMilliseconds(0);    
    return time.getTime();
}

export const formatTimestamp = (timestamp) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const date = new Date(timestamp);
    
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day} ${month}, ${year}, ${hours}:${minutes}`;
}

export const filterSingle = (a, b) => {
    if (a.length && b !== 'undefined') {
        let cat = a.filter(i => i._id === b)
        if (cat.length) {
            return cat[0].name;
        }
    }

}

export const filterSingle2 = (a, b) => a.length && (a.filter(i => i._id === b).length ? a.filter(i => i._id === b)[0].name : 'no data') ;


export const addBr = e => e ? e.replace(/\r?\n/g, '<br />') : '';
export const getBr = e => e.replace(/<br\s*\/?>/mg,"\n");

export const getHtml = e => {
    if(e){
        if(removeHtmlTags(e).trim() === ''){
            return ''
        }else{
            return parse(`<small>${e}</small>`)
        }
    }else{
        return '' 
    }
};


export const  parseHtmlAndTrim = (htmlString, trimLength = 30) =>  {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
  
    // Extract the text content from the HTML
    const textContent = tempDiv.textContent || tempDiv.innerText || '';
  
    // Trim the text to the specified length
    const trimmedText = textContent.slice(0, trimLength);
    return trimmedText;
  }



export const getdatedifference = (endDate, startdate) => {
    let sDate = new Date(parseInt(startdate));
    let eDate = new Date(parseInt(endDate));
    var Difference_In_Time = eDate.getTime() - sDate.getTime();
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    return Difference_In_Days;
}

export const onboardTypes = [
    { value: 1, label: 'Individual'},
    { value: 2, label: 'Non-Profit'},
    { value: 3, label: 'Private Company'},
    { value: 4, label: 'Public Company'},
   
]


export const businessTypes = [
    { value: 'for_profit', label: 'For Profit'},
    { value: 'non_profit', label: 'Non Profit'},
    { value: 'government_entity', label: 'Government Entity'},
    { value: 'individual', label: 'Individual'},
]

export const accountTypes = [
    { value: 'checking', label: 'Checking'},
    { value: 'savings', label: 'Savings'},
    {label: "business Checking", value: 'businessChecking'}
]

// let monthnamstart =  moment.utc(sDate).format('MMM'); 

export const gerFavpropgramdate = (startDate, endDate) => {
    let sDate = new Date(parseInt(startDate));
    let eDate = new Date(parseInt(endDate));
    let monthnamestart =  moment.utc(sDate).format('MMM')
    let monthnameend =  moment.utc(eDate).format('MMM')
    let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    let starthdatenumber = moment.utc(sDate).format('DD')
    let enddatenumber = moment.utc(eDate).format('DD')

    if(sDate.getFullYear() === eDate.getFullYear()){
        if (monthnamestart === monthnameend) {
            return `${monthnamestart} ${starthdatenumber}-${enddatenumber}, ${sDate.getFullYear()} (${days[moment.utc(sDate).day()]}-${days[moment.utc(eDate).day()]})`;
        }
        else if(sDate.getFullYear()===eDate.getFullYear())
        {
            return `${monthnamestart} ${starthdatenumber} - ${monthnameend} ${enddatenumber}, ${sDate.getFullYear()} (${days[moment.utc(sDate).day()]}-${days[moment.utc(eDate).day()]})`;
        }
    
        else {
            return `${monthnamestart} ${starthdatenumber}, ${sDate.getFullYear()} - ${monthnameend} ${enddatenumber}, ${eDate.getFullYear()} (${days[moment.utc(sDate).day()]}-${days[moment.utc(eDate).day()]})`;
        }
    }else{
        if (monthnamestart === monthnameend) {
            return `${monthnamestart} ${starthdatenumber}-${enddatenumber}, ${sDate.getFullYear()}`;
        }
        else if(sDate.getFullYear()===eDate.getFullYear())
        {
            return `${monthnamestart} ${starthdatenumber} - ${monthnameend} ${enddatenumber}, ${sDate.getFullYear()}`;
        }
    
        else {
            return `${monthnamestart} ${starthdatenumber}, ${sDate.getFullYear()} - ${monthnameend} ${enddatenumber}, ${eDate.getFullYear()}`;
        }
    }

    


}

export const getprogramdatesinCart = (startDate, endDate) => {
    //formate July 20 - July 24, 2020 
    let sDate = new Date(parseInt(startDate));
    let eDate = new Date(parseInt(endDate));
    let startdateYear = sDate.getFullYear();
    let enddateYear = eDate.getFullYear();
    let monthnamestart = moment.utc(sDate).format('MMM')
    let monthnameend =  moment.utc(eDate).format('MMM')
    let starthdatenumber = moment.utc(sDate).format('DD')
    let enddatenumber = moment.utc(eDate).format('DD')
    if (startdateYear === enddateYear) {
        return `${monthnamestart} ${starthdatenumber} - ${monthnameend} ${enddatenumber}, ${startdateYear}`;
    }
    else {
        return `${monthnamestart} ${starthdatenumber} ${startdateYear} - ${monthnameend} ${enddatenumber}, ${enddateYear}`;
    }
}

// Display helpers that use the pre-formatted date strings from the backend
// ("YYYY-MM-DD") directly — no UTC/timezone conversion, no moment dependency.

const _MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const _DAYS   = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

export const gerFavprogrmdateFromFormatted = (startDateFormatted, endDateFormatted) => {
    const [sy, sm, sd] = startDateFormatted.split('-').map(Number);
    const [ey, em, ed] = endDateFormatted.split('-').map(Number);
    const mStart = _MONTHS[sm - 1];
    const mEnd   = _MONTHS[em - 1];
    const dStart = String(sd).padStart(2, '0');
    const dEnd   = String(ed).padStart(2, '0');
    const dayStart = _DAYS[new Date(sy, sm - 1, sd).getDay()];
    const dayEnd   = _DAYS[new Date(ey, em - 1, ed).getDay()];

    if (sy === ey) {
        if (mStart === mEnd) {
            return `${mStart} ${dStart}-${dEnd}, ${sy} (${dayStart}-${dayEnd})`;
        } else {
            return `${mStart} ${dStart} - ${mEnd} ${dEnd}, ${sy} (${dayStart}-${dayEnd})`;
        }
    } else {
        if (mStart === mEnd) {
            return `${mStart} ${dStart}-${dEnd}, ${sy}`;
        } else {
            return `${mStart} ${dStart}, ${sy} - ${mEnd} ${dEnd}, ${ey}`;
        }
    }
}

/**
 * Heading for a program's own date range, e.g. "Nov 01-05, 2026 (Sun-Thu)".
 *
 * Formatting the raw timestamps with moment.utc drops the program timezone and lands a day out,
 * so read the backend's pre-formatted strings instead. Returns '' when either is missing, so a
 * partial payload renders blank rather than throwing.
 */
export const getProgramDateRangeFromFormatted = (startDateFormatted, endDateFormatted) => {
    if (!startDateFormatted || !endDateFormatted) return '';

    const [sy, sm, sd] = startDateFormatted.split('-').map(Number);
    const [ey, em, ed] = endDateFormatted.split('-').map(Number);
    const mStart = _MONTHS[sm - 1];
    const mEnd   = _MONTHS[em - 1];
    const dStart = String(sd).padStart(2, '0');
    const dEnd   = String(ed).padStart(2, '0');
    const dayStart = _DAYS[new Date(sy, sm - 1, sd).getDay()];
    const dayEnd   = _DAYS[new Date(ey, em - 1, ed).getDay()];

    if (sy === ey && sm === em && sd === ed) {
        return `${mStart} ${dStart}, ${sy} (${dayStart})`;
    }
    if (sy === ey) {
        if (sm === em) {
            return `${mStart} ${dStart}-${dEnd}, ${sy} (${dayStart}-${dayEnd})`;
        }
        return `${mStart} ${dStart} - ${mEnd} ${dEnd}, ${sy} (${dayStart}-${dayEnd})`;
    }
    return `${mStart} ${dStart}, ${sy} - ${mEnd} ${dEnd}, ${ey} (${dayStart}-${dayEnd})`;
}

export const getprogramdatesInCartFromFormatted = (startDateFormatted, endDateFormatted) => {
    const [sy, sm, sd] = startDateFormatted.split('-').map(Number);
    const [ey, em, ed] = endDateFormatted.split('-').map(Number);
    const mStart = _MONTHS[sm - 1];
    const mEnd   = _MONTHS[em - 1];
    const dStart = String(sd).padStart(2, '0');
    const dEnd   = String(ed).padStart(2, '0');
    if (sy === ey) {
        return `${mStart} ${dStart} - ${mEnd} ${dEnd}, ${sy}`;
    } else {
        return `${mStart} ${dStart} ${sy} - ${mEnd} ${dEnd}, ${ey}`;
    }
}


/*campers Dropdown*/

export const shortsAndTshirtSizes = ["Youth Small", "Youth Medium", "Youth Large", "Adult Small", "Adult Medium", "Adult Large", "Adult X-Large", "Adult XX-Large", "Adult XXX-Large"]

export const shortsAndTshirtSizes2 = ["Youth Large", "Adult Small", "Adult Medium", "Adult Large", "Adult X-Large", "Adult XX-Large", 'Adult XXX-Large']


export const medical = [{ value: 'None', label: 'None', type: 'prev' }, { value: 'ADHD', label: 'ADHD', type: 'prev' }, { value: 'Amputation', label: 'Amputation', type: 'prev' }, { value: 'Anxiety/Depression', label: 'Anxiety/Depression', type: 'prev' }, { value: 'Asperger', label: 'Asperger', type: 'prev' }, { value: 'Asthma/Respiratory Ailment', label: 'Asthma/Respiratory Ailment', type: 'prev' }, { value: 'Autism', label: 'Autism', type: 'prev' }, { value: 'Behavior/Emotional Problems', label: 'Behavior/Emotional Problems', type: 'prev' }, { value: 'Blood Disorder', label: 'Blood Disorder', type: 'prev' }, { value: 'Brain Injury', label: 'Brain Injury', type: 'prev' }, { value: 'Burn', label: 'Burn', type: 'prev' }, { value: 'Cancer', label: 'Cancer', type: 'prev' }, { value: 'Celliac Disease', label: 'Celliac Disease', type: 'prev' }, { value: 'Cerebral Palsy', label: 'Cerebral Palsy', type: 'prev' }, { value: 'Craniofacial', label: 'Craniofacial', type: 'prev' }, { value: 'Crohn’s Disease / Colitis"', label: 'Crohn’s Disease / Colitis"', type: 'prev' }, { value: 'Cystic Fibrosis', label: 'Cystic Fibrosis', type: 'prev' }, { value: 'Diabetes', label: 'Diabetes', type: 'prev' }, { value: 'Down Syndrome', label: 'Down Syndrome', type: 'prev' }, { value: 'Epilepsy', label: 'Epilepsy', type: 'prev' }, { value: 'Hearing Impairment/Deaf', label: 'Hearing Impairment/Deaf', type: 'prev' }, { value: 'Heart Defects', label: 'Heart Defects', type: 'prev' }, { value: 'Hemophilia', label: 'Hemophilia', type: 'prev' }, { value: 'HIV/Aids', label: 'HIV/Aids', type: 'prev' }, { value: 'Intellectual Disability', label: 'Intellectual Disability', type: 'prev' }, { value: 'Leukemia', label: 'Leukemia', type: 'prev' }, { value: 'Mobility Limitation', label: 'Mobility Limitation', type: 'prev' }, { value: 'Muscular Dystrophy', label: 'Muscular Dystrophy', type: 'prev' }, { value: 'Obsessive Compulsive Disorder', label: 'Obsessive Compulsive Disorder', type: 'prev' }, { value: 'Organ Transplant', label: 'Organ Transplant', type: 'prev' }, { value: 'Post-Traumatic Stress', label: 'Post-Traumatic Stress', type: 'prev' }, { value: 'Prader-Will Syndrome', label: 'Prader-Will Syndrome', type: 'prev' }, { value: 'Sickle Cell', label: 'Sickle Cell', type: 'prev' }, { value: 'Skin Disorder', label: 'Skin Disorder', type: 'prev' }, { value: 'Speech/Communication Impairment', label: 'Speech/Communication Impairment', type: 'prev' }, { value: 'Spina Bifida', label: 'Spina Bifida', type: 'prev' }, { value: 'Substance Abuse', label: 'Substance Abuse', type: 'prev' }, { value: 'Tourette Syndrome', label: 'Tourette Syndrome', type: 'prev' }, { value: 'Visual Impairment / Blind', label: 'Visual Impairment / Blind', type: 'prev' }, { value: 'Weight Loss', label: 'Weight Loss', type: 'prev' }, { value: 'Other', label: 'Other', type: 'prev' }]


export const dietGuideLines = [{ value: 'None', label: 'None', type: 'prev' }, { value: 'Gluten Free', label: 'Gluten Free', type: 'prev' }, { value: 'Vegan', label: 'Vegan', type: 'prev' }, { value: 'Vegetarian', label: 'Vegetarian', type: 'prev' }, { value: 'Pescatarian', label: 'Pescatarian', type: 'prev' }, { value: 'Other', label: 'Other', type: 'prev' }]




export const allergy = [{ value: 'None', label: 'None', type: 'prev' }, { value: "Cow's Milk", label: "Cow's Milk", type: 'prev' }, { value: 'Eggs', label: 'Eggs', type: 'prev' }, { value: 'Tree Nuts', label: 'Tree Nuts', type: 'prev' }, { value: 'Peanuts', label: 'Peanuts', type: 'prev' }, { value: 'Shellfish', label: 'Shellfish', type: 'prev' }, { value: 'Wheat', label: 'Wheat', type: 'prev' }, { value: 'Soy', label: 'Soy', type: 'prev' }, { value: 'Fish', label: 'Fish', type: 'prev' }, { value: 'Gluten', label: 'Gluten', type: 'prev' }, { value: 'Other', label: 'Other', type: 'prev' }]


export const dateFormat_second = val => {
    let d = val;
    //return d; 
    //return (d.getMonth()+1) + '/' + d.getDate() + '/' + d.getFullYear()
    return (d.getUTCMonth() + 1) + '/' + d.getUTCDate() + '/' + d.getUTCFullYear()
}

export const servingService = [
    'Junior Camp Counselor',
    'Middle School Camp Counselor',
    'High School Camp Counselor',
    'Summer Staff Kitchen/Housekeeping',
    'Summer Staff Lifegaurd',
    'Program Intern',
    'Camp Speaker',
    'Camp Nurse'

]



export const experiences = [
    {value: 1, label: 'N/A'},
    {value: 2, label: 'Novice'},
    {value: 3, label: 'Beginner'},
    {value: 4, label: 'Intermediate'},
    {value: 5, label: 'Advanced'},
    {value: 6, label: 'Expert'}
]

// `Number(e)` as well as the optional chain: the strict `===` meant a code arriving from
// the API as the string "3" matched nothing and threw on `[0].label`.
export const getExperience = e => experiences.find(item => item.value === Number(e))?.label ?? '';



export const removeAmPm = val => {
    if(val.includes('PM') || val.includes('AM') || val.includes('pm') || val.includes('am')){
        let [time, modifier] = val.split(' ');
        let [hours, minutes] = time.split(':');
        if(modifier === 'PM' || modifier === 'pm'){
            hours = parseInt(hours) + 12
        }
        return `${('0' + hours).slice(-2)}:${minutes}:00`;
    }else{
        return val
    }
  }
  
export const getCamperAge = dob => ageOn(new Date(dob), new Date());

export const dateFormatpaymentconfirm = date => moment.utc(date).format('MM/DD/YYYY');

export const gettheMessageTime =(timestamp)=>{

    var todayDate = new Date();
    var messageDate = new Date(timestamp);
    // var todayddateformate = `${todayDate.getMonth()+1}/${todayDate.getDate()}/${todayDate.getFullYear()}`;
    // var messageddateformate = `${messageDate.getMonth()+1}/${messageDate.getDate()}/${messageDate.getFullYear()}`;
    var Difference_In_Time = todayDate.getTime() - messageDate.getTime();
    var Difference_In_Days = parseInt(Difference_In_Time / (1000 * 3600 * 24)); 
    if(Difference_In_Days===0)
    {
        //return Difference_In_Days;
       return moment(messageDate).format('h:mm a');
    }
    else
    {
       // return Difference_In_Days;
       return moment(messageDate).format('MM/DD/YYYY  h:mm a');
    }    
}

export const getCroppedImg = (image, crop, fileName, format='image/png') => {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
    );

    return new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
            if (!blob) {
                console.error('Canvas is empty');
                return;
            }
            blob.name = fileName;
            resolve(new File([blob], fileName, { type: format }));
        },format);
    });
}


export const removeTime3 = t => {
    let time = new Date(t);
    time.setUTCHours(0);
    time.setUTCMinutes(0);
    time.setUTCSeconds(0);
    time.setUTCMilliseconds(0);    
    return time.getTime();
}

export const SEARCH_DEBOUNCE_DELAY = settings.searchDebounceDelay;

export const debounce = (fn, delay) => {
    let timer = null;
    return function (...args) {
        const context = this;
        timer && clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(context, args);
        }, delay);
    };
}

export const getBool = val => {
    switch(val){
        case 0: return 'No'; break;
        case 1: return 'Yes'; break;
    }
}

export const groupCodeGenerate = () =>{
  let groupCode = '';
  let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let charactersLength = characters.length;
  for (let i = 0; i < 7; i++){
    groupCode += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return groupCode;
}


export const _calculateAge = (birthday) => { // birthday is a date
    let ageDifMs = Date.now() - birthday;
    let ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}
export const _calculateAccureateAge = (birthday) => {
    const ageDifMs = Date.now() - birthday;
    const ageDate = new Date(ageDifMs);
    const years = ageDate.getUTCFullYear() - 1970;
    const months = ageDate.getUTCMonth();
    const age = years + (months / 12); 
    return Math.floor(age);
}


export const getSignature = e => {
    switch(e){
        case 1:
            return 'Mother';
        case 2:
            return 'Father';
        case 3:
            return 'Other';
        default:
            return '18 yrs or older and signing for myself';
    }
}

function webLink(link)
 {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    if (!link.match(urlRegex)) {
        return "https://" + link
    } else return link;
}

export const urlify = (text) => {
    let urlRegex = /(https?:\/\/|www\.)[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&\/=]*)/ig;

    let replacedText = text.replace(urlRegex, function (url) {
        return '<a href=' + webLink(url) + ' class="linkify"  target="_blank">' + url + '</a>';
    });
    return replacedText;
}


const zipRegex = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

export const validateZipCode = (e) => zipRegex.test(e);


export const provinceList = [
    { value: 'OR', label: 'Oregon'},
    { value: 'WA', label: 'Washington'},
    { value: 'CA', label: 'California'},
    { value: 'TX', label: 'Texas'},
    { value: 'KY', label: 'Kentucky'},
    { value: 'AK', label: 'Alaska'},
    { value: 'AL', label: 'Alabama'},
    { value: 'AZ', label: 'Arizona'},
    { value: 'AR', label: 'Arkansas'},
    { value: 'CO', label: 'Colorado'},
    { value: 'CT', label: 'Connecticut'},
    { value: 'DE', label: 'Delaware'},
    { value: 'DC', label: 'District of Columbia'},
    { value: 'FL', label: 'Florida'},
    { value: 'GA', label: 'Georgia'},
    { value: 'GU', label: 'Guam'},
    { value: 'HI', label: 'Hawaii'},
    { value: 'ID', label: 'Idaho'},
    { value: 'IL', label: 'Illinois'},
    { value: 'IN', label: 'Indiana'},
    { value: 'IA', label: 'Iowa'},
    { value: 'KS', label: 'Kansas'},
    { value: 'LA', label: 'Louisiana'},
    { value: 'ME', label: 'Maine'},
    { value: 'MH', label: 'Marshall Islands'},
    { value: 'MD', label: 'Maryland'},
    { value: 'MA', label: 'Massachusetts'},
    { value: 'MI', label: 'Michigan'},
    { value: 'MN', label: 'Minnesota'},
    { value: 'MS', label: 'Mississippi'},
    { value: 'MO', label: 'Missouri'},
    { value: 'MT', label: 'Montana'},
    { value: 'NE', label: 'Nebraska'},
    { value: 'NV', label: 'Nevada'},
    { value: 'NH', label: 'New Hampshire'},
    { value: 'NJ', label: 'New Jersey'},
    { value: 'NM', label: 'New Mexico'},
    { value: 'NY', label: 'New York'},
    { value: 'NC', label: 'North Carolina'},
    { value: 'ND', label: 'North Dakota'},
    { value: 'OH', label: 'Ohio'},
    { value: 'OK', label: 'Oklahoma'},
    { value: 'PW', label: 'Palau'},
    { value: 'PA', label: 'Pennsylvania'},
    { value: 'PR', label: 'Puerto Rico'},
    { value: 'RI', label: 'Rhode Island'},
    { value: 'SC', label: 'South Carolina'},
    { value: 'SD', label: 'South Dakota'},
    { value: 'TN', label: 'Tennessee'},
    { value: 'UT', label: 'Utah'},
    { value: 'VI', label: 'U.S. Virgin Islands'},
    { value: 'VT', label: 'Vermont'},
    { value: 'VA', label: 'Virginia'},
    { value: 'WA', label: 'Washington'},
    { value: 'WV', label: 'West Virginia'},
    { value: 'WI', label: 'Wisconsin'},
    { value: 'WY', label: 'Wyoming'},
    { value: 'ZZ', label: 'Outside U.S.'},
]



export const colorsList= [
    'aqua',
    'black',
    'blue',
    'fuchsia',
    'gray',
    'green', 
    'lime',
    'maroon',
    'navy',
    'olive',
    'orange',
    'purple',
    'red', 
    'silver',
    'teal',
    'white',
    'yellow'
];

export const triggerDropdownList = [{label:"Daily", value:1 },{label:"Weekly", value:2 },{label:"Bi-Weekly", value:3 },{label:"Monthly", value:4 }, {label:"Quarterly", value:5 },{label:"Yearly", value:6 }];

export const getTriggerType = (type, num, triggerType, list) => {
    switch (type) {
        case 1:
            return `${num} Days after regisration`;
        case 2:
            return `${num} Days prior to program start date`;
        case 3:
            return `Overdue payment`;
        case 4:
            return `Completes final payment`;
        case 5:
            return `Send ${triggerDropdownList[triggerType -1]?.label}`;
        case 6:
            return `Once new program goes live`;
        case 7:
            return `When program Information is Updated`;
        case 8:
            return `Regisrationis close`;
        case 9:
            return `New coupon is created`;
        case 11:
            return `Send ${triggerDropdownList[triggerType -1]?.label} to Non-Approved Participants `;
        default:
            return '';
    }
}


export const getRightTime = scheduleTime => {
    let _hh = new Date(scheduleTime).getHours();
    let _mm = new Date(scheduleTime).getMinutes();

    if(_mm.toString().length === 1){
        _mm = "0" + _mm;
    }
    if(_hh.toString().length === 1){
        _hh = "0" + _hh;
    }
    return `T${_hh}:${_mm}:00`;
}

// export const calculateEMIPaymentDates = (campStartDate, emiCount, emiAmount) => {
//     const bookingDate = Date.now();
//     const timeDifference = campStartDate - bookingDate;   
//     const daysDifference = Math.floor(timeDifference / 86400000);
//     let sufficientDays= 60+(emiCount*45);


//     if(daysDifference > sufficientDays){
//         const paymentInterval = 45
//         const paymentDates = [];
//         for (let i = 1; i <= emiCount; i++) {
//             let paymentDate = bookingDate
//             paymentDate = paymentDate + i  * paymentInterval * 86400000;
//             paymentDates.push({
//                 emiAmount: emiAmount,
//                 emiDate: paymentDate,
//                 status: 2
//             });
//         }
//         return paymentDates;
//     }
//     else {
//         const paymentInterval = Math.floor((daysDifference - 60) / emiCount);
//         if (paymentInterval < 1) {
//             return "Split payment not available";
//         }
//         const paymentDates = [];
//         for (let i = 1; i <= emiCount; i++) {
//             let paymentDate = bookingDate
//             paymentDate = paymentDate + i * paymentInterval * 86400000; 
//             paymentDates.push({
//                 emiAmount: emiAmount,
//                 emiDate: paymentDate,
//                 status: 2
//             });
//         }
//         return paymentDates;
//     }
// }

export const SPORTS_INTERNATIONAL = "Sports International"

/**
 * Which booking forms apply to a participant, from the program's Super Admin sliders (1 on, 2 off).
 * Shared by the parent booking page and the director Documents card. Mirrors the API's
 * `getMissingDocuments` (bookingFacade.js): change both together.
 * - Key Deposit: `is_keydrom` on, and not for commuters. Off unless set, as at checkout.
 * - Concussion: `isParentAthlete` on. Off unless set, as at checkout.
 * - Medical Clearance: on unless `isMedicalClearance` is 2 (programs from before the slider have none).
 * Waiver Disclaimer always applies, so it isn't listed.
 */
export const getApplicableDocuments = (program, camper) => ({
    keyDeposit: Number(program?.is_keydrom) === 1 && !camper?.isCommuter,
    concussion: Number(program?.isParentAthlete) === 1,
    medicalClearance: Number(program?.isMedicalClearance) !== 2,
});
export const calculateEMIPaymentDates = (campStartDate, emiCount, emiAmount) => {
    const bookingDate = moment.utc().startOf('day').valueOf();
    let sevencampStartDate = campStartDate - (7 * 24 * 60 * 60 * 1000)
    const timeDifference = sevencampStartDate - bookingDate;   
    const daysDifference = Math.floor(timeDifference / 86400000);
    let sufficientDays= emiCount*45;
    if(daysDifference > sufficientDays){
        const paymentInterval = 45
        const paymentDates = [];
        for (let i = 1; i <= emiCount; i++) {
            let paymentDate = bookingDate
            paymentDate = paymentDate + i  * paymentInterval * 86400000;
            paymentDates.push({
                emiAmount: emiAmount,
                emiDate: paymentDate,
                status: 2
            });
        }
        return paymentDates;
    }
    else {
        const paymentInterval = Math.floor((daysDifference) / emiCount);
        if (paymentInterval < 1) {
            return "Split payment not available";
        }
        const paymentDates = [];
        for (let i = 1; i <= emiCount; i++) {
            let paymentDate = bookingDate
            paymentDate = paymentDate + i * paymentInterval * 86400000; 
            paymentDates.push({
                emiAmount: emiAmount,
                emiDate: paymentDate,
                status: 2
            });
        }
        return paymentDates;
    }
}


export const hasSplitOption = (campStartDate, emiCount) => {
    const timeDifference = campStartDate - Date.now();    
    const daysDifference = timeDifference / 86400000;
    if (daysDifference > 29) {
        return true;
    }else {
        return false;
    }
}


export const calMultiDatesPrices = dates => {
    let _price = 0;
    for (let i = 0; i < dates.length; i++) {
        _price += dates[i].standardPrice
    } 
    return _price;
}

export const convertDateToCustomFormat =  date => moment.utc(date).format('MM/DD/YYYY hh:mm A');
  

export const hasMatchingAnswers = (options, answers, optionOperator) => {
    if (answers !== undefined && (optionOperator === 1 || optionOperator === 2)) {
        if (optionOperator === 1) {
            const optionsSet = new Set(options);
            for (let i = 0; i < answers.length; i++) {
                if (optionsSet.has(answers[i])) {
                    return true;
                }
            }
            return false;
        } else if (optionOperator === 2) {
            const answersSet = new Set(answers);
            return options.every(option => answersSet.has(option));
        }
    }
    return false;
};
export const  isSubset = (array1, array2) => {
    return array1.every(element => array2.includes(element));
  }
  

export const isNonEmptyArray = (items) => {
    return  (items.filter(obj => Object.keys(obj).length !== 0 || obj.constructor !== Object).length > 0)
 }


 export const trimWhiteSpacesFromArrayElements = (arr) => arr.map(element => element.trim());

 export const  isLessThanEquals14Days = (startDate)  => {
    const start = new Date(startDate);
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    const differenceInMs =  start - now;
    const differenceInDays = differenceInMs / (1000 * 60 * 60 * 24);
    return differenceInDays <= 14;
}

export const  isValidJSON = (jsonString) =>  {
    try {
        const jsonObject = JSON.parse(jsonString);
        return typeof jsonObject === 'object' && jsonObject !== null;
    } catch (e) {
        return false;
    }
}

export const calculateProductRefundPrice = (product, feeRatio = 1) => {
        let productPrice = product.itemPrice * product.quantity;
        if(product?.subItems.length > 0){
            for(let i=0; i< product?.subItems?.length ; i++ ){
                productPrice += product?.subItems[i].price * product?.subItems[i].count;
            }
        }
        if(product?.paymentArr[0]?.refunds?.length > 0){
            let _allItemRefunds = product?.paymentArr[0]?.refunds.filter(rf => rf?.metadata?.itemId === product?.itemId)
            let _refundedAmount = 0;
            if(_allItemRefunds?.length > 0){
                for(let i=0; i<_allItemRefunds.length; i++){
                    _refundedAmount += _allItemRefunds[i].amount;
                }
            }
            // refund records store the fee-inclusive amount actually refunded; convert back to the base amount before subtracting
            productPrice-= (feeRatio > 0 ? _refundedAmount / feeRatio : _refundedAmount);
        }
       if( productPrice <= 0 ){
            return 0
       }
        return Number(productPrice.toFixed(2));
}

export const calculateProductRefundWithFee = (bookingAmount, bookingApplicationFee, refundAmount) => {
    if(refundAmount<=0){
        return 0;
    }
    const preFeeTotal = bookingAmount - bookingApplicationFee;
    if(!bookingApplicationFee || bookingApplicationFee <= 0 || preFeeTotal <= 0){
        return refundAmount;
    }
    const feeShare = (refundAmount / preFeeTotal) * bookingApplicationFee;
    return Number((refundAmount + feeShare).toFixed(2));
}

export const initialChargeAmountModalState = {
    amount: 0,
    description: '',
    reasonErr: '',
    camperList: [],
    chargeModal: false,
    selectedCamper: '',
    bookingNumber: '',
    bookingId: '',
    programId: ''

};

export function ChargeAmountReducer(state, action) {
    switch (action.type) {
        case 'SET_REASON':
            return { ...state, description: action.payload };
        case 'SET_REASON_ERROR':
            return { ...state, reasonErr: action.payload };
        case 'SET_AMOUNT':
            return { ...state, amount: action.payload };
        case 'SET_CAMPERLIST':
            return { ...state, camperList: action.payload };
        case 'SET_CAMPER_CHANGE':
            return { ...state, selectedCamper: action.payload };
        case 'SET_META_DATA':
            return {
                ...state,
                bookingNumber: action.payload.b_no,
                bookingId: action.payload.b_id,
                programId: action.payload.p_id,
            };
        case 'RESET':
            return initialChargeAmountModalState;
        default:
            return state;
    }
}


export const getCardTypeName = (type) => {
    const typeMap = {
        'american express': 'AmericanExpress',
        'visa electron': 'Visa',
        'visa': 'Visa',
        'mastercard': 'MasterCard',
        'discover': 'Discover',
        'china_unionpay': 'Unionpay',
        'diners club': 'DinersClub',
        'dinersclub': 'DinersClub'
    };

    return typeMap[type.toLowerCase()] || 'Visa';
}
export const getCardTypeImage = (brand) => {
    try {
      // Dynamically require the image based on the brand
      return require(`./assets/img/${getCardTypeName(brand)}.svg`);
    } catch (error) {
      return require(`./assets/img/Visa.svg`);
    }
}

export const getPriceCategory= (registration, timestamp, selectionPrice) =>  {
    if(!registration){
        return {label:"Program Fee", value:0}
    }
    if (timestamp >= registration.dateEarlyRegisterOpen && timestamp <= registration.dateEarlyRegisterClosed) {
        return {label: "Early Bird Program Fee", value: selectionPrice.earlyBirdPrice}
    } else if (timestamp >= registration.registerOpenDate && timestamp <= registration.registerCloseDate) {
        return {label:"Program Fee", value: selectionPrice.registrationFee}
    } else if (registration.dateLateRegisterOpen && registration.dateLateRegisterClosed) {
        if (timestamp >= registration.dateLateRegisterOpen && timestamp <= registration.dateLateRegisterClosed) {
            return {label:"Late Registration Fee", value: selectionPrice.lateRegistrationFee}
        }
    }
    return {label:"Program Fee", value: 0}
}

export const setProgramPrice = (campRegistrationFee, purchaseType) =>  {
    const priceDetail = {};
    let label;
    
    if( purchaseType === 0 ){
        label = "Early Bird Program Fee";
    }
    else if( purchaseType === 1 ){
        label = "Program Fee";
    }
    else if( purchaseType === 2 ){
        label = "Late Registration Fee";
    }

    priceDetail.label = label;
    priceDetail.value = campRegistrationFee;

    return priceDetail;
}

export const isLessThan600msAgo = (inputDate) => {
    const now = new Date();
    return now - inputDate >= 600;
  };

  export const isMoreThan1sAgo = (inputDate) => {
    const now = new Date();
    return (now - inputDate)>= 1500;
  };

  export const findFirstState = (arr) => {
    for (const camper of arr) {
      if (Array.isArray(camper)) {
        for (const item of camper) {
          if (item.state) return item.state;
        }
      } else if (camper?.state) {
        return camper.state;
      }
    }
    return "OR";
  };

  export const calculateInsuranceAmount = (f_campRegistrationFee, f_convenienceFee, noOfCampers, additionalExperienceTotal, couponMoney) => {
    return (((Math.round(f_campRegistrationFee + f_convenienceFee )/noOfCampers* 100) / 100 + additionalExperienceTotal - couponMoney) * 100).toFixed(0)
  }

  export const bookingSteps = [{title: 'ADD PROGRAM TO CART', }, {title: 'CONFIRM DETAILS',}, {title: 'PROCEED TO PAYMENT'},]

  export const calculateInsuranceCamperDisplay = (insuranceAmount, insuranceData = []) => {
    let _insuranceTotal = insuranceAmount;
    if(insuranceData?.length > 0){
       const _purcahsedInsurance = insuranceData?.filter(ins => ins.insuranceStatus !== 2)
       if(_purcahsedInsurance.length > 0){
        _insuranceTotal = _purcahsedInsurance?.reduce((acc, ins) => acc  + ins.total, 0)
       }
    }
    return _insuranceTotal
  }

  export const getUserTimezone = () => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return userTimezone
  }
  export const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
export const convertTimeToCurrentTimeZone = (date, timeZone = userTimezone, format) => {
    if(timeZone === ''){
        timeZone= userTimezone
    }
    const converted = momentTz(date).tz(timeZone).format(format);
    return converted;
}

export const PaymentDateFormat = 'MMM DD, YYYY | h:mm:ss a';

export const Timezones = momentTz.tz.names().map((tz) => ({
    value: tz,
    label: `(GMT${moment.tz(tz).format("Z")}) ${tz}`,
  }));

export const  isEmptyOrWhitespace = (str) => {
    return str.trim() === '';
  }

 export  const updateFields = (target, source, compulsoryFields = []) => {
    Object.entries(source).forEach(([key, value]) => {
      if (key in target) {
        target[key] = value;
      }
    });
    compulsoryFields.forEach((field) => {
        if (field in source) {
          target[field] = source[field];
        }
      });
    return target;
  };


  export const  compareAndUpdateObject = (target, source) =>  {
    let update = false;
    Object.keys(target).forEach((key) => {
      if (source[key] !== target[key]) {
        update = true;
      }
    });
    return update;
  }

export const paraClass = 'd-flex justify-content-between align-items-center'


export const combineDateAndTimeToUTC = (dateMs, timeMs) => {
      const datePart = moment.utc(dateMs);
  
      const timePart = moment.utc(timeMs);
      const hours = timePart.hours();
      const minutes = timePart.minutes();
      const seconds = timePart.seconds();
  
      datePart.set({ hour: hours, minute: minutes, second: seconds, millisecond: 0 });
  
      return datePart.toISOString();
  };
  export const notificationMsg = (status,description="Something went wrong, please try again.", message= "") => {
    if(status){
        notification.open({message,description,});
    }else{
        notification.open({description});
    }
}

export const sortByTimestamp = (data, order = "asc", timeStamp='date') => {
    return data.sort((a, b) => order === "asc" ? a[timeStamp] - b[timeStamp] : b[timeStamp]- a[timeStamp]);
  };

const AUDIT_ACTION_LABELS = {
    insurance_purchased: 'Insurance Purchased',
    emi_schedule_created: 'EMI Schedule Created',
    emi_amount_edited: 'EMI Amount Edited',
    booking_date_edited: 'Booking Date Edited',
    document_reminder_sent: 'Document Reminder Sent',
    group_assignment_approved: 'Group Assignment Approved',
    group_assignment_unapproved: 'Group Approval Removed',
    medical_review_approved: 'Medical Clearance Approved',
    medical_review_unapproved: 'Medical Clearance Approval Removed',
    medical_approval_email_sent: 'Medical Approval Email Sent',
    program_created: 'Program Created',
};

// Overrides for specific field names (exact case as they appear on the entry / in the
// parsed description JSON) where the generic camelCase humanizer reads awkwardly.
const AUDIT_KEY_LABELS = {
    product: 'Insurance',
    tshirt: 'T-Shirt',
    expLevel: 'Experience Level',
    noOfSlots: 'Available Slots',
    attendanceHour: 'Alternate Last Day Check-Out Time',
};

// Value lookups for fields this app stores as numeric/string codes elsewhere in the
// UI (see AddProgramModal.js's genders3/facilies/trueFalse/experiences option lists).
// Kept as plain objects here rather than reusing those shared list-lookup helpers
// (getProgramType, getFacility, etc.) because those throw on an unrecognized value —
// audit history can contain legacy/out-of-range codes, and one bad entry shouldn't be
// able to crash the whole audit trail. An unmatched code just falls through below.
const codeMap = list => Object.fromEntries(list.map(item => [item.value, item.label]));

const AUDIT_CODED_VALUES = {
    gender: { 1: 'Male', 2: 'Female', 3: 'Co-Ed' },
    // Derived from the shared option lists rather than copied, so the four fields whose
    // dropdowns were widened cannot drift out of step with the audit trail again. The
    // fall-through below still guards an unmapped code, which is the property that keeps
    // this table safe where the direct lookups were not.
    facility: codeMap(ALL_FACILITIES),
    travel: codeMap(travelOpt),
    tshirt: codeMap(tshirtOpt),
    scholarships: codeMap(scholarshipOpt),
    isotheroption: { 1: 'Yes', 2: 'No' },
    isrequred: { 1: 'Yes', 2: 'No' },
    isonline: { 1: 'Yes', 0: 'No' },
    explevel: { 1: 'N/A', 2: 'Novice', 3: 'Beginner', 4: 'Intermediate', 5: 'Advanced', 6: 'Expert' },
};

const humanizeAuditKey = key => AUDIT_KEY_LABELS[key] || (key || '')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/^./, s => s.toUpperCase());

// The backend logs per-question edits as synthetic field paths:
// `question[Question Title].subField`, `question.added`, `question.removed`. Give
// them a readable label instead of running them through the generic humanizer as-is.
const describeAuditField = field => {
    const bracketMatch = (field || '').match(/^question\[(.+)\]\.(.+)$/);
    if (bracketMatch) return `${bracketMatch[1]} - ${humanizeAuditKey(bracketMatch[2])}`;
    if (field === 'question.added') return 'Question Added';
    if (field === 'question.removed') return 'Question Removed';
    return humanizeAuditKey(field);
};

// The key used for value-type detection (coded lookups, date/amount formatting) —
// for `question[Title].subField` that's the subField, not the whole synthetic path.
const auditValueKey = field => {
    const bracketMatch = (field || '').match(/^question\[(.+)\]\.(.+)$/);
    return bracketMatch ? bracketMatch[2] : field;
};

const isDateLikeAuditValue = (key, value) => {
    const num = Number(value);
    return /date/i.test(key || '') && Number.isFinite(num) && num > 1000000000000;
};

const formatAuditArrayValue = value => {
    if (!value.length) return 'None';
    return value.map(item => (item && typeof item === 'object')
        ? (item.opt ?? item.name ?? item.label ?? JSON.stringify(item))
        : String(item)
    ).join(', ');
};

const formatAuditValue = (rawKey, value) => {
    if (value === null || value === undefined || value === '') return '';
    // Some entries send a genuinely-unset value as the literal string "null" rather
    // than JSON null (e.g. isOnline) — treat it the same as empty.
    if (typeof value === 'string' && value.toLowerCase() === 'null') return '';
    if (Array.isArray(value)) return formatAuditArrayValue(value);

    const key = auditValueKey(rawKey);
    const lowerKey = (key || '').toLowerCase();

    if (lowerKey === 'programtype') return getProgramType(value);
    const codedLookup = AUDIT_CODED_VALUES[lowerKey];
    if (codedLookup && codedLookup[Number(value)] !== undefined) return codedLookup[Number(value)];

    if (value === true || value === 'true') return 'Yes';
    if (value === false || value === 'false') return 'No';

    if (isDateLikeAuditValue(key, value)) return moment(Number(value)).format('MMM DD, YYYY');
    // previousValue/updatedValue on the same entry are frequently mismatched types
    // (one a real number, the other a numeric string) — coerce both the same way
    // rather than requiring `typeof value === 'number'`, or only one side of a diff
    // gets the $/% suffix.
    if (/amount|price|fee/i.test(lowerKey)) {
        const num = Number(value);
        if (Number.isFinite(num)) return `$${num}`;
    }
    if (lowerKey === 'tax') {
        const num = Number(value);
        if (Number.isFinite(num)) return `${num}%`;
    }

    // Rich-text fields (impNotes, disclaimer, etc.) store raw HTML; strip tags rather
    // than printing them literally. Detected by content, not field name, so it covers
    // any HTML-backed field without hardcoding the list.
    if (typeof value === 'string' && /<[a-z][\s\S]*>/i.test(value)) {
        return removeHtmlTags(value).replace(/\s+/g, ' ').trim();
    }
    return String(value);
};

// audit.description is a JSON string of extra context whose shape varies by action
// type; parsed generically here (id-like keys dropped) rather than per-type, so
// unrecognized future action types still render something readable.
const auditDescriptionDetail = description => {
    let parsed;
    try { parsed = JSON.parse(description); } catch (e) { return description || ''; }
    if (!parsed || typeof parsed !== 'object') return '';
    return Object.entries(parsed)
        .filter(([k]) => !/id$/i.test(k))
        .map(([k, v]) => `${humanizeAuditKey(k)}: ${formatAuditValue(k, v)}`)
        .join(', ');
};

// Shared normalizer for audit entries into { label, detail, by, at } for display
// in an audit trail timeline. `booking.audits[]` (bookingCamperDetail API) and
// `program.auditHistory[]` both use the same entry shape: either a named action
// (field === 'action' or an explicit actionLabel, with context in `description`)
// or a plain field value change (previousValue -> updatedValue).
const formatAuditEntry = entry => {
    // question.added / question.removed are single-value events (a question was
    // created or deleted), not a before/after diff of one field.
    if (entry.field === 'question.added' || entry.field === 'question.removed') {
        const value = entry.field === 'question.added' ? entry.updatedValue : entry.previousValue;
        return {
            label: describeAuditField(entry.field),
            detail: formatAuditValue(entry.field, value),
            by: entry.updatedByName || 'Unknown',
            at: entry.createdAt,
        };
    }

    const isPureActionEntry = entry.field === 'action';
    const hasNamedAction = isPureActionEntry || !!entry.actionLabel;
    // actionLabel names the action whenever the backend provides it, regardless of
    // which field it's attached to; only fall back to updatedValue (the older shape,
    // where field === 'action' and the action name rides in updatedValue instead).
    const actionKey = entry.actionLabel || (isPureActionEntry ? entry.updatedValue : null);
    const label = hasNamedAction
        ? (AUDIT_ACTION_LABELS[actionKey] || humanizeAuditKey(actionKey) || 'Updated')
        : `${describeAuditField(entry.field)} Changed`;

    let detail = auditDescriptionDetail(entry.description);
    if (!isPureActionEntry && entry.updatedValue !== undefined) {
        const updatedFormatted = formatAuditValue(entry.field, entry.updatedValue);
        // previousValue may be a real value, an empty string, or missing from the
        // entry entirely (e.g. disableOvernight) — all "nothing there before" cases
        // read the same to a user, so treat them identically.
        const prevFormatted = entry.previousValue !== undefined ? formatAuditValue(entry.field, entry.previousValue) : '';

        let change = '';
        if (prevFormatted && updatedFormatted) {
            change = `${prevFormatted} → ${updatedFormatted}`;
        } else if (updatedFormatted) {
            change = `Set to ${updatedFormatted}`;
        } else if (prevFormatted) {
            change = `Cleared (was ${prevFormatted})`;
        }
        // Both sides resolving to nothing (e.g. previousValue: null, updatedValue: "null")
        // means there's no meaningful value to show — leave detail as-is rather than
        // showing an empty change.
        if (change) {
            detail = detail ? `${change} (${detail})` : change;
        }
    }

    return { label, detail, by: entry.updatedByName || 'Unknown', at: entry.createdAt };
};

export const formatBookingAuditEntry = formatAuditEntry;
export const formatProgramAuditEntry = formatAuditEntry;

export const isProd = () => {
      switch (process.env.REACT_APP_ENV) {
        case 'dev' || 'development':
          return false;
        case 'local' || 'local ':
          return false;
        case 'prod' || 'prod ' || 'production':
            return true;
        default:
          return false;
      }
}

export const detectTrafficSource = () => {
    const params = new URLSearchParams(window.location.search);

    const src = params.get('src');
    const sku = params.get('sku');
    const _gl = params.get('_gl');

    // AdShopper tracking parameters
    const adshopperClickId = params.get('adshopper_click_id');
    const utmSource = params.get('utm_source');
    const utmMedium = params.get('utm_medium');
    const utmCampaign = params.get('utm_campaign');
    const utmContent = params.get('utm_content');
    const utmTerm = params.get('utm_term');

    if (!src && !sku && !_gl && !adshopperClickId && !utmSource) return null;

    return {
        src: src?.toLowerCase() || null,
        sku: sku?.toLowerCase() || null,
        _gl: _gl?.toLowerCase() || null,
        adshopperClickId: adshopperClickId || null,
        utmSource: utmSource?.toLowerCase() || null,
        utmMedium: utmMedium?.toLowerCase() || null,
        utmCampaign: utmCampaign?.toLowerCase() || null,
        utmContent: utmContent?.toLowerCase() || null,
        utmTerm: utmTerm?.toLowerCase() || null,
    };
};

export const sortByValueOrder = (data, valueOrder) => {
    return data.slice().sort((a, b) => {
        return valueOrder.indexOf(a.value) - valueOrder.indexOf(b.value);
    });
}

export const  isCardExpired = (expMonth, expYear) =>  {
  const today = new Date();
  const currentMonth = today.getMonth() + 1;
  const currentYear = today.getFullYear();

  if (expYear < currentYear) return true;

  if (expYear === currentYear && expMonth < currentMonth) return true;

  return false;
}

export const smallReactSelector = {
    control: (base) => ({
      ...base,
      fontSize: '0.75rem',      // Tailwind's text-xs
      minHeight: '32px',
      height: '32px',
      padding: '0 6px',
    }),
    input: (base) => ({
      ...base,
      fontSize: '0.75rem',
      margin: '0',
      padding: '0',
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: '0.75rem',
    }),
    option: (base) => ({
      ...base,
      fontSize: '0.75rem',
      padding: '6px 8px',
    }),
    menu: (base) => ({
      ...base,
      fontSize: '0.75rem',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: '32px',
    }),
    valueContainer: (base) => ({
      ...base,
      padding: '0 6px',
    }),
  }


export const getConfirmedCamps = (camps) => {
    const seen = new Set(); 
    if(camps?.length === 0 ){
        return []
    }

    return camps
        .filter(camp => camp.detailConfirmed === 1) 
        .filter(camp => {
            if (seen.has(camp.campId)) return false; 
            seen.add(camp.campId);
            return true;
        })
        .map(camp => ({
            campId: camp.campId,
            campName: camp.campName
        }));
}

export const getRegistrationPrice = ({
    dateEarlyRegisterOpen, dateEarlyRegisterClosed, dateLateRegisterOpen, dateLateRegisterClosed,
    earlyBirdPrice, registrationFee, lateRegistrationFee }, now = Date.now()) => {

    const current = Number(now);

    if (current >= dateEarlyRegisterOpen && current <= dateEarlyRegisterClosed) {
        return earlyBirdPrice;
    }

    if (current >= dateLateRegisterOpen && current <= dateLateRegisterClosed) {
        return lateRegistrationFee;
    }
    return registrationFee;
}

/**
 * Headline price for a program card: the server's `listPrice` — active tier +
 * registerNonRefundFee, before any special deal or discount.
 *
 * Cards render this as the sticker price and strike it through (`.cm_spacial_price`) when a
 * special deal runs, with `specialDealsPrice` shown beneath it, so this one must stay pre-deal.
 * Discounts are deducted at payment rather than while browsing, which keeps this equal to the
 * "Camp Registration Fee" line that heads the parent's price breakdown in the cart.
 *
 * Cards used to re-derive the price here, which skipped the per-tier overrides; the fallback
 * keeps that arithmetic for any payload without the field, so nothing regresses if a card is
 * fed from an endpoint that does not compute it.
 *
 * Valid for every program, `byDates === 1` included: the server prices those from their cheapest
 * still-bookable date block plus registerNonRefundFee, so one call covers both kinds. Card sites
 * used to branch on byDates into their own local helper that read `additionalDates[0]`, which
 * quoted the first block in stored order rather than the cheapest available one and disagreed
 * with the detail page. Do not reintroduce that branch.
 *
 * The fallback is tier arithmetic, which a byDates program's fields cannot answer — it would
 * quote the bare registerNonRefundFee as the price. Every endpoint that feeds a card computes
 * `listPrice`, so this is unreachable today; it yields nothing rather than a fabricated number if
 * a new one ever forgets, and re-deriving block prices in the browser would just recreate the
 * second source of truth this function exists to remove.
 */
export const getCardPrice = program =>
    program?.listPrice
        ?? (program?.byDates === 1
            ? 0
            : getRegistrationPrice(program || {}) + (program?.registerNonRefundFee || 0));

/**
 * Physician phone as the phone input expects it (E.164).
 *
 * The parent forms used to save it as bare digits while the director forms save `+1…`, and the
 * phone input shows nothing for a value that isn't E.164. Lifts a US number saved as bare digits
 * to `+1…`; anything else is returned untouched.
 */
export const toE164US = value => {
    const phone = String(value || '').trim();
    if (!phone || phone.startsWith('+')) return phone;
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 10) return `+1${digits}`;
    if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
    return phone;
};
